import React from "react";

const ToggleAudio = ({ isToggle, setIsToggle }) => {
  return (
    <div className="flex items-center justify-center">
      <label
        for="check"
        className={
          isToggle === false
            ? "display:inline-block relative  w-[35px] h-[17px] md:h-6 md:w-12 cursor-pointer rounded-full border-2 border-gray-100 bg-gray-100"
            : "display:inline-block relative  w-[35px] h-[17px]  md:h-6 md:w-12 cursor-pointer rounded-full border-2 border-[#bbffe5] bg-[#bbffe5]"
        }
      >
        <input
          type="checkbox"
          id="check"
          className="peer sr-only"
          onClick={(event) => setIsToggle(!isToggle)}
        />
        <span
          className={!isToggle ? "absolute top-0  left-0 h-4 w-4 md:h-5  md:w-5 cursor-pointer rounded-full transition-all duration-500" : "absolute top-0 h-4 w-4 md:h-5  md:w-5 cursor-pointer rounded-full transition-all duration-500 left-4 md:left-6 bg-rose-600"}
          style={
            isToggle === false
              ? {
                  background:
                    "#a7a7a7",
                }
              : {
                  background:
                    "#1ca571",
                }
          }
        ></span>
      </label>
    </div>
  );
};

export default ToggleAudio;